//src/api/general/api.js
import api from '../index';
import { url } from './routes';
import { getCsrfToken } from '../../utils';

const ensureCsrf = async () => {
  if (getCsrfToken()) return;                // уже есть
  await api.get('/csrf-token');              // сервер положит cookie
};

/* ---------- пользователь/сессия ---------- */
// Позволяем передавать дополнительный config, например validateStatus/timeout
export const getMe      = (config) => api.get(url('me'), config);
export const getCoins   = () => api.get (url('coins'));
export const getProfile = () => api.get (url('profile'));
export const getRole    = () => api.get (url('role'));
export const logoutUser = async () => {
  await ensureCsrf();                        // ← гарантируем cookie
  return api.post(
    url('logout'),
    null,
    { headers: { 'X-CSRF-Token': getCsrfToken() } },
  );
};